import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { validateForm } from '@shared/helpers/form.helpers';
import { AuthService } from '../../auth.service';
import { BehaviorSubject } from 'rxjs';

import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { MessageModule } from 'primeng/message';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';


@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [RouterModule, TranslateModule, ReactiveFormsModule, ButtonModule, FloatLabelModule, MessageModule, InputTextModule],
})

export class ForgotPasswordComponent implements OnInit {
    logoPath = '';
    emailSent$ = new BehaviorSubject<boolean>(false);
    disableButton = false;



    form = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
    });


    constructor(
        private router: Router,
        public auth: AuthService
    ) { }

    ngOnInit(): void {

    }

    submit(): void {
        if (this.form.valid) {
            this.emailSent$.next(true);
            this.disableButton = true;
            this.auth.resetPassword(this.form.value.email.toLowerCase().trim());
        } else {
            validateForm(this.form);
        }
    }

    navigateToLogin(): void {
        this.router.navigate(['/app/login']);
    }
}
